import { CATEGORIES_SERVICE } from "@/services/categories.service.js";

const state = { listOutput: null };

const actions = {
    getList({ dispatch, commit }, inputGetCategories) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        CATEGORIES_SERVICE.list(inputGetCategories)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    }
};


export const categories = {
    namespaced: true,
    state,
    actions,
    mutations
};